import { render, staticRenderFns } from "./DomainComponent.vue?vue&type=template&id=df5381a8&"
import script from "./DomainComponent.vue?vue&type=script&lang=ts&"
export * from "./DomainComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports